// R1b-β Step 3 — Approvals inbox (AdminAppShell-wrapped, clickable rows).
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AdminAppShell } from "../../design-system/shells/AdminAppShell";
import EmptyState from "../../components/EmptyState";
import StatusChip from "../../components/StatusChip";
import { useAuth } from "../../lib/auth";
import { api } from "../../lib/api";
import { FileCheck2 } from "lucide-react";

const STATUS_KIND = {
  awaiting_recommendation: "pending_approval",
  pending: "pending_approval",
  approved: "approved",
  executed: "approved",
  verified: "approved",
  executed_verification_failed: "error",
  rejected: "rejected",
};

export default function ApprovalsAdmin() {
  const [items, setItems] = useState([]);
  const { user } = useAuth();

  useEffect(() => { api.get("/approvals").then(r => setItems(r.data)); }, []);

  return (
    <AdminAppShell
      activeNav="people-access"
      title="Approvals Inbox"
      subtitle="Centralized queue · full state machine"
      breadcrumbs={[
        { label: "People & Access", to: "/admin/people-roles/users" },
        { label: "Approvals" },
      ]}
      user={user}
    >
      <div className="mx-auto w-full max-w-[1600px] px-4 md:px-6 lg:px-8" data-testid="approvals-inbox">
        {items.length === 0 ? (
          <EmptyState
            icon={FileCheck2}
            title="Zero pending approvals"
            subtitle="Operational queue is clear. Approval requests appear here as CRM, Contracts, and Change Orders start generating them."
            testId="approvals-empty"
          />
        ) : (
          <div className="bg-white border border-erf-borderCream rounded-md overflow-x-auto">
            <table className="w-full erf-table">
              <thead className="bg-erf-creamSecondary">
                <tr>
                  <th className="text-left px-3 py-2">Type</th>
                  <th className="text-left px-3 py-2">Status</th>
                  <th className="text-left px-3 py-2">Requested at</th>
                  <th className="text-left px-3 py-2">Requested by</th>
                  <th className="text-left px-3 py-2">Current step</th>
                  <th className="text-left px-3 py-2"></th>
                </tr>
              </thead>
              <tbody>
                {items.map((a) => (
                  <tr key={a.id} className="border-t border-erf-borderCream/60 hover:bg-erf-creamSecondary/40"
                      data-testid={`approval-row-${a.id}`}>
                    <td className="px-3 py-2 font-nav">{a.request_type}</td>
                    <td className="px-3 py-2">
                      <StatusChip status={STATUS_KIND[a.overall_status] || "pending_approval"}
                                  label={a.overall_status.replace(/_/g, " ")} />
                    </td>
                    <td className="px-3 py-2 mono text-[11px]">{(a.created_at || "").slice(0, 19)}</td>
                    <td className="px-3 py-2 mono text-[11px]">{(a.requested_by || "").slice(0, 8)}</td>
                    <td className="px-3 py-2 mono">{(a.current_step ?? 0) + 1}/{(a.steps || []).length}</td>
                    <td className="px-3 py-2 text-right">
                      <Link to={`/admin/approvals/${a.id}`} data-testid={`approval-link-${a.id}`}
                            className="text-erf-gold hover:underline text-xs font-nav">Open →</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </AdminAppShell>
  );
}
